import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getActiveUser, getMultipageFormValues } from 'Store/reducers';
import { isAnActualObject } from '../utilities';
import {
  getPlanByLicense,
  getPaidLicenseByType,
} from 'Settings/pricing-options';
import NewSchoolPayment from 'Containers/Payment/NewSchoolPayment';
import Loading from 'Components/Loading';
import { withRouter } from 'react-router';
import { ROUTES } from 'Settings/route-strings';

class NewAccountPaymentPage extends React.PureComponent {
  state = {
    valuesLoadedFromStore: false,
  };

  componentDidMount() {
    // Check to see if we have an active user and send them on their way.
    if (this.props.activeUser) {
      this.props.history.push(ROUTES.INDEX);
    }

    this.setInitialFieldValues();
  }

  componentDidUpdate() {
    this.setInitialFieldValues();
  }

  setInitialFieldValues = () => {
    const { multipageFormValues } = this.props;
    const valuesLoadedFromStore = isAnActualObject(multipageFormValues);
    const newState = {
      valuesLoadedFromStore,
    };
    if (!valuesLoadedFromStore || this.state.values) return;

    if (valuesLoadedFromStore && !multipageFormValues.username)
      this.props.history.push(ROUTES.SUBSCRIPTION_USERNAME);

    const {
      username,
      password,
      family_name,
      given_name,
      schoolName,
    } = multipageFormValues;
    if (
      valuesLoadedFromStore &&
      username &&
      password &&
      family_name &&
      given_name &&
      schoolName
    ) {
      newState.values = {};
      newState.values.user = {
        auth_info: {
          username,
          password,
        },
        family_name,
        given_name,
      };
      newState.values.school = {
        name: schoolName,
      };
      const licenseType =
        multipageFormValues.licenseType || getPaidLicenseByType.school;

      newState.values.initialPlan = getPlanByLicense(licenseType);
      this.setState(newState);
    } else {
      this.props.history.push(ROUTES.SUBSCRIPTION_CREATE_ACCOUNT);
    }
  };

  render() {
    if (!this.state.valuesLoadedFromStore) return <Loading />;

    return <NewSchoolPayment {...this.state.values} />;
  }
}

const mapStateToProps = state => {
  return {
    activeUser: getActiveUser(state),
    multipageFormValues: getMultipageFormValues(state, 'loggedOutPayment'),
  };
};

NewAccountPaymentPage.propTypes = {
  history: PropTypes.object,
  activeUser: PropTypes.object,
  multipageFormValues: PropTypes.object,
};

export default withRouter(
  connect(mapStateToProps, false)(NewAccountPaymentPage)
);
